import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "area_title" }
const _hoisted_3 = { class: "area_button" }
const _hoisted_4 = { class: "area_body" }
const _hoisted_5 = { class: "area_section" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "area_section" }
const _hoisted_8 = { class: "area_ul" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ItemAdd = _resolveComponent("ItemAdd")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("p", null, "홍보물품대장", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.showModal && $setup.showModal(...args)))
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("span", null, "수정", -1)
            ]))]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.confirmRemove && $setup.confirmRemove(...args)))
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("span", null, "삭제", -1)
            ]))])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: $setup.state.data.file,
              style: {"width":"300px","height":"auto"}
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", null, [
                _cache[6] || (_cache[6] = _createElementVNode("label", null, "물품명", -1)),
                _createElementVNode("p", {
                  textContent: _toDisplayString($setup.state.data.name)
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("li", null, [
                _cache[7] || (_cache[7] = _createElementVNode("label", null, "등록자", -1)),
                _createElementVNode("p", {
                  textContent: _toDisplayString($setup.state.data.writer)
                }, null, 8, _hoisted_10)
              ]),
              _createElementVNode("li", null, [
                _cache[8] || (_cache[8] = _createElementVNode("label", null, "부서", -1)),
                _createElementVNode("p", {
                  textContent: _toDisplayString($setup.state.data.team)
                }, null, 8, _hoisted_11)
              ]),
              _createElementVNode("li", null, [
                _cache[9] || (_cache[9] = _createElementVNode("label", null, "잔고량", -1)),
                _createElementVNode("p", null, _toDisplayString($setup.state.data.cnt ? $setup.CommonUtils.numberFormat($setup.state.data.cnt) : "0"), 1)
              ]),
              _createElementVNode("li", null, [
                _cache[10] || (_cache[10] = _createElementVNode("label", null, "등록일자", -1)),
                _createElementVNode("p", {
                  textContent: _toDisplayString($setup.CommonUtils.dateFormat($setup.state.data.createDate, '.', true))
                }, null, 8, _hoisted_12)
              ]),
              _createElementVNode("li", null, [
                _cache[11] || (_cache[11] = _createElementVNode("label", null, "최근 입고일", -1)),
                _createElementVNode("p", {
                  textContent: _toDisplayString($setup.CommonUtils.dateFormat($setup.state.data.recentEntireDate, '.', true))
                }, null, 8, _hoisted_13)
              ])
            ])
          ])
        ])
      ])
    ]),
    ($setup.state.isShowAddModal)
      ? (_openBlock(), _createBlock(_component_ItemAdd, {
          key: 0,
          data: $setup.state.data,
          onCallback: $setup.itemUpdate,
          onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.state.isShowAddModal = false))
        }, null, 8, ["data", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 1,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callbackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}